import * as React from 'react';
import { asyncLoadModule } from './async-load-util';
import { ModuleConfig } from 'src/types/configTypes';
import { SuspenseLoadingWidget } from '@axa-asia/emma-loading-widget';

type AsyncComponentState = {
  loadedComponent: ModuleConfig['routes'][string]['container'];
};

/**
 *
 * @param moduleFolder - The module folder name to load. This will be used to load corrspondent saga and reducer.
 * @param route - The next route to load. This will be used to load corrspondent container.
 * @param dependencyModuleFolder - The dependency to load. This will be loaded first.
 * @returns
 */
export function withAsync(
  moduleFolder: string,
  route: string,
  dependencyModuleFolder?: string[],
) {
  return class extends React.Component<unknown, AsyncComponentState> {
    static displayName = `AsyncComponent`;

    constructor(props) {
      super(props);

      this.state = {
        loadedComponent: null,
      };
    }

    componentDidMount() {
      asyncLoadModule(moduleFolder, true, route)
        .then((container) => {
          this.setState({
            loadedComponent: container,
          });
        })
        .catch((e) => {
          console.error(e);
        });

      if (dependencyModuleFolder) {
        dependencyModuleFolder.forEach((v) => {
          asyncLoadModule(v, false);
        });
      }
    }

    render() {
      const LoadedComponent = this.state.loadedComponent;

      if (!LoadedComponent) {
        return <SuspenseLoadingWidget />;
      }

      return <LoadedComponent {...this.props} />;
    }
  };
}
